function SkeletonItem() {
  return (
    <div className="bg-purple-brand-950 border-purple-brand-800 raised raised-purple-brand-800 flex animate-pulse items-center gap-4 rounded-xl border-2 px-4 py-3">
      <div className="flex flex-1 flex-col gap-1.5">
        <div className="bg-purple-brand-800 h-4 w-24 rounded" />
        <div className="bg-purple-brand-800 h-3.5 w-16 rounded" />
      </div>
    </div>
  );
}

export function PlanChoiceboxSkeleton() {
  return (
    <div className="flex w-full flex-col gap-3">
      <SkeletonItem />
      <SkeletonItem />
    </div>
  );
}
